import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { labelOf } from "./FormUtil";
import { useAccent } from "./SectionCard";

// One form field: label above the control, two fields per row on desktop
const FormField = ({ name, required, full, children }) => {
  const { accentName } = useAccent();

  return (
    <Grid
      item
      xs={12}
      md={full ? 12 : 6}
      sx={() => {
        const focus = "#C89B3C";
        return {
          // Outlined inputs: replace the blue focus border (errors stay red)
          "& .MuiOutlinedInput-root.Mui-focused:not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderColor: focus,
            borderWidth: "2px",
          },
          "& .MuiInputBase-root.Mui-focused": {
            boxShadow: "none",
            outline: "none",
          },
          "& .MuiInput-root:after": { borderBottomColor: focus },
        };
      }}
    >
      <MDBox mb={0.75}>
        <MDTypography
          variant="button"
          fontWeight="medium"
          textTransform="capitalize"
          color={accentName}
        >
          {labelOf(name)}
          {required && (
            <MDTypography component="span" variant="button" fontWeight="bold" color="error">
              {" *"}
            </MDTypography>
          )}
        </MDTypography>
      </MDBox>
      {children}
    </Grid>
  );
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  full: PropTypes.bool,
  children: PropTypes.node,
};

FormField.defaultProps = {
  required: false,
  full: false,
  children: null,
};

export default FormField;
